import { Injectable } from '@angular/core';
import { MenuItem, MenuRegistryService, MenuSection } from '@app/core';

import {
  AppActions,
  AppFeature,
  getClaimString,
} from '../../shared/constants/app-claims';

const menuItems: MenuItem[] = [
  {
    id: 'graphs',
    name: 'Inspecciones',
    type: 'graphs',
    dataSource: { url: 'graphs/inspections' },
    icon: 'analytics',
    order: 1,
    neededClaim: getClaimString(AppFeature.GraphsInspections, AppActions.Read),
  },
];

const menuSection: MenuSection = {
  id: 'graphs',
  name: 'Gráficos',
  items: menuItems,
  order: 1,
  neededClaim: getClaimString(AppFeature.Graphs, AppActions.Read),
};

@Injectable({
  providedIn: 'root',
})
export class GraphsModule {
  constructor(private menuRegistry: MenuRegistryService) {
    this.menuRegistry.registerModule(menuSection);
  }

  static getMenuItems(): MenuItem[] {
    return menuItems;
  }
}
